import { OrderStatus } from "./authStatus";

export enum ColoredText {
  Standard = "#0F0F0F",
  Expedited = "#CC0300",
  Routine = "#665D00",
  True = "#005d49",
  False = "#CC0300",
  Inprogress = "#665D00",
}

export const BadgeTextColor: { [key in OrderStatus]: string } = {
  [OrderStatus.New]: "#0056D6",
  [OrderStatus.Drafts]: "#0F0F0F",
  [OrderStatus.Pending]: "#C24400",
  [OrderStatus.Inprogress]: "#665D00",
  [OrderStatus.Approved]: "#005D49",
  [OrderStatus.Denied]: "#CC0300",
  [OrderStatus.Closed]: "#0F0F0F",
  [OrderStatus.PartiallyApproved]: "#C24400",
  [OrderStatus.Submitted]: "#0056D6",
  [OrderStatus.Error]: "#CC0300",
  [OrderStatus.Received]: "#A030A0",
  [OrderStatus.FORM_FILLED]: "#665D00",
  [OrderStatus.QA_FETCHED]: "#0056D6",
  [OrderStatus.FORM_ERROR]: "#CC0300",
  [OrderStatus.INACCURACY]: "#CC0300",
  [OrderStatus.VERIFIED]: "#005D49",
  [OrderStatus.NO_STATUS]: "#0F0F0F",
  [OrderStatus.SENT_TO_PLAN]: "#C24400",
  [OrderStatus.IN_PROGRESS]: "#A030A0",
  [OrderStatus.SENDING_TO_PLAN]: "#0F0F0F",
  [OrderStatus.AUTH_NOT_REQUIRED]: "#005D49",
  [OrderStatus.AUTH_NEEDED]: "#C24400",
  [OrderStatus.SUCCESS]: "#005D49",
  [OrderStatus.WAITING_FOR_DETERMINATION]: "#C24400",
  [OrderStatus.QA_ERROR]: "#CC0300",
  [OrderStatus.QA_IN_PROGRESS]: "#665D00",
  [OrderStatus.NOT_SEND_TO_PLAN]: "#0F0F0F",
  [OrderStatus.ARCHIVED]: "#0F0F0F",
  [OrderStatus.AUTH_ON_FILE]: "#005D49",
  [OrderStatus.UNKNOWN]: "#0F0F0F",
  [OrderStatus.UNSPECIFIED]: "#0F0F0F",
  [OrderStatus.NO_AUTH_REQUIRED]: "#005D49",
  [OrderStatus.SENDING_TO_PLAN_ERROR]: "#CC0300",
  [OrderStatus.PRESCRIPTION_ERROR]: "#CC0300",
  [OrderStatus.INSURANCE_ERROR]: "#CC0300",
  [OrderStatus.QA_NOT_FOUND]: "#CC0300",
  [OrderStatus.QA_INCOMPLETE]: "#CC0300",
  [OrderStatus.DIAGNOSIS_ERROR]: "#CC0300",
  [OrderStatus.DOSE_ERROR]: "#CC0300",
  [OrderStatus.PATIENT_ERROR]: "#CC0300",
  [OrderStatus.TREATMENT_PLAN_ERROR]: "#CC0300",
  [OrderStatus.TREATMENT_PLAN_CHANGED]: "#C24400",
  [OrderStatus.MEDICATION_ERROR]: "#CC0300",
  [OrderStatus.SEND_TO_PLAN_ERROR]: "#CC0300",
  [OrderStatus.FIRST_STP_OUTCOME]: "#111111",
  [OrderStatus.NOT_STARTED]: "#0F0F0F",
  [OrderStatus.UPDATING_QA]: "#665D00",
  [OrderStatus.QA_UPDATED]: "#0056D6",
  [OrderStatus.QA_UPDATE_ERROR]: "#CC0300",
  [OrderStatus.SUBMITTING_PA]: "#665D00",
  [OrderStatus.PA_SUBMITTED]: "#0056D6",
  [OrderStatus.SUBMISSION_ERROR]: "#CC0300",
};

export const BadgeColor: { [key in OrderStatus]: string } = {
  [OrderStatus.New]: "#EAF2FF",
  [OrderStatus.Drafts]: "#F5F5F5",
  [OrderStatus.Pending]: "#FFF3E0",
  [OrderStatus.Inprogress]: "#FFFCD6",
  [OrderStatus.Approved]: "#E6F3F0",
  [OrderStatus.Denied]: "#FFE8E8",
  [OrderStatus.Closed]: "#F5F5F5",
  [OrderStatus.PartiallyApproved]: "#FFF3E0",
  [OrderStatus.Submitted]: "#EAF2FF",
  [OrderStatus.Error]: "#FFE8E8",
  [OrderStatus.Received]: "#EEE6FBFF",
  [OrderStatus.FORM_FILLED]: "#FFFCD6",
  [OrderStatus.QA_FETCHED]: "#EAF2FF",
  [OrderStatus.FORM_ERROR]: "#FFE8E8",
  [OrderStatus.INACCURACY]: "#FFE8E8",
  [OrderStatus.VERIFIED]: "#E6F3F0",
  [OrderStatus.NO_STATUS]: "#F5F5F5",
  [OrderStatus.SENT_TO_PLAN]: "#FFF3E0",
  [OrderStatus.IN_PROGRESS]: "#EEE6FBFF",
  [OrderStatus.SENDING_TO_PLAN]: "#F5F5F5",
  [OrderStatus.AUTH_NOT_REQUIRED]: "#E6F3F0",
  [OrderStatus.AUTH_NEEDED]: "#FFF3E0",
  [OrderStatus.SUCCESS]: "#E6F3F0",
  [OrderStatus.WAITING_FOR_DETERMINATION]: "#FFF3E0",
  [OrderStatus.QA_ERROR]: "#FFE8E8",
  [OrderStatus.QA_IN_PROGRESS]: "#FFFCD6",
  [OrderStatus.NOT_SEND_TO_PLAN]: "#F6F6F6",
  [OrderStatus.ARCHIVED]: "#F6F6F6",
  [OrderStatus.AUTH_ON_FILE]: "#E6F3F0",
  [OrderStatus.UNKNOWN]: "#F6F6F6",
  [OrderStatus.UNSPECIFIED]: "#F6F6F6",
  [OrderStatus.NO_AUTH_REQUIRED]: "#E6F3F0",
  [OrderStatus.SENDING_TO_PLAN_ERROR]: "#FFE8E8",
  [OrderStatus.PRESCRIPTION_ERROR]: "#FFE8E8",
  [OrderStatus.INSURANCE_ERROR]: "#FFE8E8",
  [OrderStatus.QA_NOT_FOUND]: "#FFE8E8",
  [OrderStatus.QA_INCOMPLETE]: "#FFE8E8",
  [OrderStatus.DIAGNOSIS_ERROR]: "#FFE8E8",
  [OrderStatus.DOSE_ERROR]: "#FFE8E8",
  [OrderStatus.PATIENT_ERROR]: "#FFE8E8",
  [OrderStatus.TREATMENT_PLAN_ERROR]: "#FFE8E8",
  [OrderStatus.TREATMENT_PLAN_CHANGED]: "#FFF3E0",
  [OrderStatus.MEDICATION_ERROR]: "#FFE8E8",
  [OrderStatus.SEND_TO_PLAN_ERROR]: "#FFE8E8",
  [OrderStatus.FIRST_STP_OUTCOME]: "#F5F5F5",
  [OrderStatus.NOT_STARTED]: "#F5F5F5",
  [OrderStatus.UPDATING_QA]: "#FFFCD6",
  [OrderStatus.QA_UPDATED]: "#EAF2FF",
  [OrderStatus.QA_UPDATE_ERROR]: "#FFE8E8",
  [OrderStatus.SUBMITTING_PA]: "#FFFCD6",
  [OrderStatus.PA_SUBMITTED]: "#EAF2FF",
  [OrderStatus.SUBMISSION_ERROR]: "#FFE8E8",
};
